import React from 'react';
import { useTranslation } from 'yardi-react-translation/translationService';

// Default messages
const DEFAULT_MESSAGE = 'Loading your application...';
const DEFAULT_SUB_MESSAGE = 'Please wait while we process your request...';

interface LoadingScreenVisualProps {
  displayMessage?: string;
  subMessage?: string;
}

interface ApplicationLoadingScreenProps {
  message?: string;
  subMessage?: string;
}

/**
 * Pure visual component - no hooks, just renders the loading screen.
 * Use this directly when you can't use React hooks (e.g., before providers mount).
 */
export const LoadingScreenVisual: React.FC<LoadingScreenVisualProps> = ({
  displayMessage = DEFAULT_MESSAGE,
  subMessage = DEFAULT_SUB_MESSAGE,
}) => {
  return (
    
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          {/* Spinning loader matching ApplicationCharges style */}
          <div className="relative">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-primary mx-auto"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-8 h-8 bg-primary rounded-full opacity-20 animate-pulse"></div>
            </div>
          </div>
          
          {/* Loading message */}
          <div className="mt-6 space-y-2">
            <p className="text-lg font-medium text-foreground">{displayMessage}</p>
            <p className="text-sm text-muted-foreground">
              {subMessage}
            </p>
          </div>
          
          {/* Progress dots animation */}
          <div className="flex justify-center mt-4 space-x-1">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>
      </div>
   
  );
}; 

/**
 * Translated loading screen - uses useTranslation hook.
 */
export const ApplicationLoadingScreen: React.FC<ApplicationLoadingScreenProps> = ({
  message,
  subMessage,
}) => {
  const { t } = useTranslation();
  return (
    <LoadingScreenVisual
      displayMessage={t(message || DEFAULT_MESSAGE)}
       subMessage={t(subMessage || DEFAULT_SUB_MESSAGE)}
    />
  );
}; 